export const toLabel = (group, labels) => {
    const label = labels?.[group] ?? group;
    return "" + (label.label ?? label);
};
